<template>
  <section class="bg-lifeboost-red-lighter pt-44 sm:pt-20 font-ww-medium">
    <div class="flex flex-wrap xl:flex-nowrap items-center justify-center px-5 pb-8">
      <div v-for="(logo, index) in logos" :key="index" class="w-1/2 md:w-1/3 lg:w-auto py-3 px-5">
        <nuxt-img
            class="w-full mix-blend-darken"
            width="386"
            height="120"
            loading="lazy"
            format="webp"
            :alt="logo.alt"
            sizes="xs:120px sm:160px md:260px lg:231px xl:280px 2xl:386px"
            :src="logo.src"
        />
      </div>
    </div>
  </section>
</template>

<script setup>


const props = defineProps({
  logos: {
    type: Array,
    default: () => [
      { src: '/assets/images/logo-coffee-1.png', alt: 'Inc. 500 Logo' },
      { src: '/assets/images/logo-coffee-2.png', alt: 'inside indiana' },
      { src: '/assets/images/logo-coffee-3.png', alt: 'Coffee Affection Logo' },
      { src: '/assets/images/logo-coffee-4.png', alt: 'allrecipes Logo' },
      { src: '/assets/images/logo-coffee-5.png', alt: 'Little Coffee Place Logo' }
      // Add additional logos as needed
    ]
  }
});

defineBuilderComponent({
    friendlyName: "Logos Coffee",
    inputs: [
        {
            name: "logos",
            type: "list",
            defaultValue: [
                {
                    src: "/assets/images/logo-coffee-1.png",
                    alt: "Inc. 500 Logo"
                },
                {
                    src: "/assets/images/logo-coffee-2.png",
                    alt: "inside indiana"
                },
                {
                    src: "/assets/images/logo-coffee-3.png",
                    alt: "Coffee Affection Logo"
                },
                {
                    src: "/assets/images/logo-coffee-4.png",
                    alt: "allrecipes Logo"
                },
                {
                    src: "/assets/images/logo-coffee-5.png",
                    alt: "Little Coffee Place Logo"
                }
            ],
            subFields: [
                {
                    name: "src",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png"
                    ],
                    required: true
                },
                {
                    name: "alt",
                    type: "string"
                }
            ]
        }
    ]
});
</script>